import { useContext } from 'react'
import { ErrorBoundary } from '@sentry/react'

import { ErrorPage } from 'components'
import { AppThemeContext } from './AppThemeProvider'

const AppErrorProvider = ({ children }) => {
  const appTheme = useContext(AppThemeContext)

  return (
    <ErrorBoundary
      beforeCapture={(scope) => {
        //@ts-ignore
        scope.setTag('webpack_public_path', __webpack_public_path__)
      }}
      fallback={<ErrorPage chameleonTheme={appTheme.chameleonTheme} errorCode="unexpected-error" />}
    >
      {children}
    </ErrorBoundary>
  )
}

export default AppErrorProvider
